/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IContactUpdateMutationVariables = Types.Exact<{
  contactId: Types.Scalars['ID']['input'];
  contactParams: Types.IContactUpdateParams;
}>;

export type IContactUpdateMutation = {
  __typename?: 'Mutation';
  contactUpdate?: {
    __typename?: 'ContactUpdatePayload';
    success: boolean;
    errors?: Array<string> | null;
    contact?: {
      __typename?: 'Contact';
      id: string;
      email: string;
      name: string;
      phone?: string | null;
      signatory: boolean;
      contactType: Types.ContactTypeEnum;
      escrow:
        | {
            __typename?: 'ContinuityEscrow';
            id: string;
            depositorConfigured: boolean;
            beneficiaryConfigured: boolean;
            agreement: { __typename?: 'Agreement'; policy: { __typename?: 'AgreementPolicy'; generate: boolean } };
          }
        | {
            __typename?: 'SaasEscrow';
            id: string;
            depositorConfigured: boolean;
            beneficiaryConfigured: boolean;
            agreement: { __typename?: 'Agreement'; policy: { __typename?: 'AgreementPolicy'; generate: boolean } };
          }
        | {
            __typename?: 'SoftwareEscrow';
            id: string;
            depositorConfigured: boolean;
            beneficiaryConfigured: boolean;
            agreement: { __typename?: 'Agreement'; policy: { __typename?: 'AgreementPolicy'; generate: boolean } };
          };
    } | null;
  } | null;
};

export const ContactUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'contactUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactParams' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactUpdateParams' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contactId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contactParams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'contactParams' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContactFragment' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'escrow' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'depositorConfigured' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryConfigured' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agreement' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'policy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'generate' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signatory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IContactUpdateMutation, IContactUpdateMutationVariables>;
